
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchCommercialContacts } from './fetch-commercial-contacts';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-commercial-contacts`;
};

/**
 * `useCommercialContacts` hook.
 */

function useCommercialContacts<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchCommercialContacts(variables);
  }, {
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useCommercialContacts` hook.
 */

export default useCommercialContacts;
